import { render } from "./UIListBox.vue?vue&type=template&id=f5b237e0"
import script from "./UIListBox.vue?vue&type=script&lang=ts"
export * from "./UIListBox.vue?vue&type=script&lang=ts"
script.render = render

export default script